import React from 'react';

export default function ErrorMessage({ title, subtitle, ...rest }) {
  return (
    <section className="col-12 request-failed" {...rest}>
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </section>
  );
}
